import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import SlashBG from './../../assets/images/homepage/slash.webp'
import Slider from "react-slick";
import Logo1 from './../../assets/images/homepage/logo/1.webp'
import Logo1PNG from './../../assets/images/homepage/logo/1.png'
import Logo2 from './../../assets/images/homepage/logo/2.webp'
import Logo2PNG from './../../assets/images/homepage/logo/2.png'
import Logo3 from './../../assets/images/homepage/logo/3.webp'
import Logo3PNG from './../../assets/images/homepage/logo/3.png'
import Logo4 from './../../assets/images/homepage/logo/4.webp'
import Logo4PNG from './../../assets/images/homepage/logo/4.png'
import Logo5 from './../../assets/images/homepage/logo/5.webp'
import Logo5PNG from './../../assets/images/homepage/logo/5.png'
import Logo6 from './../../assets/images/homepage/logo/6.webp'
import Logo6PNG from './../../assets/images/homepage/logo/6.png'
import Logo7 from './../../assets/images/homepage/logo/7.webp'
import Logo7PNG from './../../assets/images/homepage/logo/7.png'
import Logo8 from './../../assets/images/homepage/logo/8.webp'
import Logo8PNG from './../../assets/images/homepage/logo/8.png'
import Logo9 from './../../assets/images/homepage/logo/9.webp'
import Logo9PNG from './../../assets/images/homepage/logo/9.png'
import Logo10 from './../../assets/images/homepage/logo/10.webp'
import Logo10PNG from './../../assets/images/homepage/logo/10.png'
import Logo11 from './../../assets/images/homepage/logo/11.webp'
import Logo11PNG from './../../assets/images/homepage/logo/11.png'
import Logo12 from './../../assets/images/homepage/logo/12.webp'
import Logo12PNG from './../../assets/images/homepage/logo/12.png'
import Logo13 from './../../assets/images/homepage/logo/13.webp'
import Logo13PNG from './../../assets/images/homepage/logo/13.png'
import Logo14 from './../../assets/images/homepage/logo/14.webp'
import Logo14PNG from './../../assets/images/homepage/logo/14.png'
import Logo15 from './../../assets/images/homepage/logo/15.webp'
import Logo15PNG from './../../assets/images/homepage/logo/15.png'
import Logo16 from './../../assets/images/homepage/logo/16.webp'
import Logo16PNG from './../../assets/images/homepage/logo/16.png'
import ArrowLeft from './../../assets/images/arrow-left-black.png'
import ArrowRight from './../../assets/images/arrow-right-black.png'
import rectangleGolden from './../../assets/images/rectangle-golden.png'
import rectangleGray from './../../assets/images/rectangle-gray.png'
import clsx from 'clsx'
import { useInView } from 'react-intersection-observer';
import { injectIntl } from 'react-intl';

const LogoArray = [
    { webp: Logo1, png: Logo1PNG },
    { webp: Logo2, png: Logo2PNG },
    { webp: Logo3, png: Logo3PNG },
    { webp: Logo4, png: Logo4PNG },
    { webp: Logo5, png: Logo5PNG },
    { webp: Logo6, png: Logo6PNG },
    { webp: Logo7, png: Logo7PNG },
    { webp: Logo8, png: Logo8PNG },
    { webp: Logo9, png: Logo9PNG },
    { webp: Logo10, png: Logo10PNG },
    { webp: Logo11, png: Logo11PNG },
    { webp: Logo12, png: Logo12PNG },
    { webp: Logo13, png: Logo13PNG },
    { webp: Logo14, png: Logo14PNG },
    { webp: Logo15, png: Logo15PNG },
    { webp: Logo16, png: Logo16PNG },]

const useStyles = makeStyles((theme) => ({
    root: {
        background: `url(${SlashBG}) #001229`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        "& .title-block": {
            padding: "140px 0px 70px 0px",

            // backgroundImage: `url(${SlashBG})`,
            [theme.breakpoints.down('sm')]: {
                padding: "100px 0px 50px 0px",
            },
            [theme.breakpoints.down('sm')]: {
                padding: "60px 0px 40px 0px",
            },
        },
        "& .title": {
            textAlign: "center", transform: "translateY(50px)",
            opacity: "0",
            transition: "0.6s",
            "&.inView": {
                transform: "translateY(0px)",
                opacity: "1",
            }
        },
        "& .subtitle": {
            maxWidth: "500px",
            margin: "12px auto 0px auto",
            color: "rgba(255,255,255,0.2)",
            textAlign: "center",
            opacity: "0",
            transition: "0.6s",
            transform: "translateY(50px)",
            [theme.breakpoints.down('sm')]: {
                maxWidth: "295px",
            },
            "&.inView": {
                transform: "translateY(0px)",
                opacity: "1",
            }
        },
        "& .content-block": {
            padding: "71px 0px",
            position: "relative",
            background: "#fff",
            "&:before": {
                position: "absolute",
                top: "-120px",
                left: "0px",
                content: "''",
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "120px 0 0 50vw",
                borderColor: "transparent transparent transparent #fff",
                [theme.breakpoints.down('sm')]: {
                    top: "-60px",
                    borderWidth: "60px 0 0 50vw",
                },
                [theme.breakpoints.down('xs')]: {
                    top: "-39px",
                    borderWidth: "40px 0 0 50vw",
                },
            },
            "&:after": {
                transition: "0.6s",
                position: "absolute",
                top: "-120px",
                right: "0px",
                content: "''",
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 0 120px 50vw",
                borderColor: "transparent transparent #fff transparent",
                [theme.breakpoints.down('sm')]: {
                    top: "-60px",
                    borderWidth: "0 0 60px 50vw",
                },
                [theme.breakpoints.down('xs')]: {
                    top: "-39px",
                    borderWidth: "0 0 40px 50vw",
                },

            },
            [theme.breakpoints.down('sm')]: {
                padding: "20px 0px"
            },
        },
        "& .logo-block": {
            padding: "0px 36px 40px 36px",
            maxWidth: "1072px",
            margin: "0px auto",
            "& li button:before": {
                content: "''",
                backgroundSize: "cover",
                width: "10px",
                height: "10px",
                backgroundImage: `url(${rectangleGray})`,
                opacity: "0.8"
            },
            "& .slick-active button:before": {
                backgroundImage: `url(${rectangleGolden})`
            }
        },
        "& .logo-icon": {
            width: "100%",
            height: "auto"
        },
        "& .MuiGrid-container": {
            display: "flex !important"
        },
        "& .slick-arrow": {
            width: "14px",
            height: "23px",
            backgroundSize: "cover !important",
            transition: "0.3s",
            "&:before": {
                content: "unset"
            },
            "&.slick-disabled": {
                opacity: "0.25"
            },
            [theme.breakpoints.down('sm')]: {
                width: "8px",
                height: "13px",
            }
        },
        "& .slick-dots": {
            left: "0px"
        },
        "& .slick-prev": {
            left: "12px",
            backgroundImage: `url(${ArrowLeft}) !important`,
        },
        "& .slick-next": {
            right: "12px",
            backgroundImage: `url(${ArrowRight}) !important`,
        },
        "& .MuiGrid-spacing-xs-2 > .MuiGrid-item": {
            padding: "12px 0px"
        }


    }
}))
const ClientLogo = (props: any) => {
    const classes = useStyles()
    const { isMobileScreen, disableBackground, intl } = props
    const [titleRef, titleInView, titleEntry] = useInView(
        {
            threshold: 0,
        });
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <div className={classes.root} style={{ background: disableBackground ? "#001229" : `url(${SlashBG}) #001229 cover,center` }}>
            <div className="title-block" >
                <Typography className={clsx("title", titleInView && "inView")} variant="h3" >{intl.formatMessage({ id: "empowerList.clientLogo.title" })}</Typography>
                <Typography className={clsx("subtitle", titleInView && "inView")} variant="h6" ref={titleRef}>{intl.formatMessage({ id: "empowerList.clientLogo.subtitle" })}</Typography>
            </div>
            <div className="content-block">
                <Slider {...settings} className="logo-block">
                    <Grid container spacing={2}>
                        {LogoArray.slice(0, 8).map((item: any, index: number) =>
                            <Grid item xs={6} key={index}>
                                <picture>
                                    <source srcSet={item.webp} type="image/webp" />
                                    <img className="logo-icon" src={item.png} alt={intl.formatMessage({ id: `empowerList.clientLogo.logo${index + 1}Alt` })} />
                                </picture>
                            </Grid>
                        )}
                    </Grid>
                    <Grid container spacing={2}>
                        {LogoArray.slice(8, 16).map((item: any, index: number) =>
                            <Grid item xs={6} key={index}>
                                <picture>
                                    <source srcSet={item.webp} type="image/webp" />
                                    <img className="logo-icon" src={item.png} alt={intl.formatMessage({ id: `empowerList.clientLogo.logo${index + 1}Alt` })} />
                                </picture>
                            </Grid>
                        )}
                    </Grid>
                </Slider>
            </div>
        </div>
    )
}
export default injectIntl(ClientLogo);